
export default {
  beforeRouteEnter: (to, from, next) => {
    // 获取路径参数
    const param = to.query;
    if (!param) {
      next();
      return;
    }
    next(vm => {
      vm.$data.param = param; // 保存路径参数
      // 重定向到不带 query 参数的路径
      const { path } = to;
      next({ path, replace: true }); // 用 replace: true 防止在历史记录中留下带参数的记录
    });
  },
  provide() {
    return {
      getParam: () => this.param,
      getIsInit: () => this.isInit,
    };
  },
  watch: {
    param: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            if (this.param && this.isInit) {
              this.isInit = false;
              setTimeout(() => {
                this.setDefaultFilterValue('customTb1', 'tabIndex', 'status');
              }, 1000);
            } else {
              this.setDefaultFilterValue('customTb1', 'tabIndex', 'status');
            }
          });
        }
      },
      immediate: true
    },
  },
  methods: {
    // setDefaultFilterValue() {
    //   console.log('setDefaultFilterValue');
    //   this.setDefaultFilterValue('customTb1', 'tabIndex', 'status');
    // }
  },
  created() {
    // 节流处理
    // this.setDefaultFilterValueHandler = this.$debounce(() => {
    //   this.setDefaultFilterValue('customTb1', 'tabIndex', 'status');
    // }, 500);
    // this.$nextTick(() => {
    //   // 使用 $nextTick 确保这个方法在下一轮事件循环中被提供
    //   this.$set(this, 'setDefaultFilterValueHandler', this.setDefaultFilterValueHandler);
    // });
  },
  data() {
    return {
      param: null,
      // 初次挂载
      isInit: true,
    };
  },
};
